import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>3239 Legends Preserve Dr, Daytona Beach, FL 32124</h1>
        <h2 style={{ color: 'green' }}>
          Golf View & Lake View
        </h2>
        4 Beds | 3 Baths | 2,190 Sqft | Build in 2024 | $???
        <br />
        <br />
   
        <p>
          Energy-efficient home! An open-concept floorplan with 4 bedrooms, 3 bathrooms, and a 2-car garage. 
          This home features a spacious kitchen that overlooks the great room, dining, and covered lanai.
          This beautifully serene community is just 12 miles from Daytona's stunning beaches. 
          Located on International Golf Drive alongside the world-famous LPGA golf course, 
          residents will have easy access to both I-4 and I-95, as well as Daytona International Airport. 
          Nearby attractions include Daytona International Speedway, Tanger Outlets, and the Daytona Boardwalk.
        </p>

<h3>Interior</h3>
<h4>Bedrooms</h4>
<ul>
  <li>Total Bedrooms: 4</li>
  <li>Primary Bedroom Dimensions: 13 X 16</li>
  <li>Primary Bedroom Level: First</li>
</ul>
<h4>Other Rooms</h4>
<ul>
  <li>Total Rooms: 3</li>
  <li>Great Room Dimensions: 16 X 21</li>
  <li>Great Room Level: First</li>
</ul>
<h4>Bathrooms</h4>
<ul>
  <li>Total Bathrooms: 3</li>
  <li>Full Bathrooms: 3</li>
</ul>
<h4>Interior Features</h4>
<ul>
  <li>Eat-In Kitchen</li>
  <li>Open Floorplan</li>
  <li>Thermostat</li>
  <li>Flooring: Carpet, Ceramic Tile</li>
</ul>

<h4>Appliances</h4>
<ul>
  <li>Dishwasher</li>
  <li>Disposal</li>
  <li>Microwave</li>
  <li>Range</li>
  <li>Laundry Features: Inside</li>
</ul>
<h4>Heating and Cooling</h4>
<ul>
  <li>Cooling Features: Central Air</li>
  <li>Heating Features: Central</li>
</ul>
<h4>Kitchen and Dining</h4>
<ul>
  <li>Kitchen Dimensions: 16 X 9</li>
  <li>Kitchen Level: First</li>
</ul>

<h3>Exterior</h3>
<h4>Exterior and Lot Features</h4>
<ul>
  <li>Sidewalk</li>
  <li>Sliding Doors</li>
  <li>Road Responsibility: Public Maintained Road</li>
  <li>Road Surface Type: Asphalt</li>
</ul>
<h4>Patio and Porch</h4>
<ul>
  <li>Covered Lanai</li>
</ul>
<h4>Manufactured and Mobile Info</h4>
<ul>
  <li>Builder Model: Emilia</li>
</ul>

<h4>Garage and Parking</h4>
<ul>
  <li>Attached Garage: Yes</li>
  <li>Garage Spaces: 2</li>
  <li>Garage Features: 20 X 20</li>
  <li>Parking Features: Driveway</li>
</ul>
<h4>Land Info</h4>
<ul>
  <li>Lot Size Acres: 0.1434803</li>
  <li>Lot Size Dimensions: 50 X 125</li>
  <li>Lot Size Square Feet: 6250</li>
</ul>
<h4>Community</h4>
<h4>Homeowners Association</h4>
<ul>
  <li>Association: Yes</li>
  <li>Association Fee: 85</li>
  <li>Association Fee Frequency: Monthly</li>
  <li>Calculated Total Monthly Association Fees: 85</li>
  <li>Association Name: Legends Preserve Homeowners Association Inc</li>
  <li>Association Phone: 3868681414</li>
  <li>Pets Allowed: Yes</li>
</ul>
<h4>School Information</h4>
<ul>
  <li>Elementary School: Champion Elementary School</li>
  <li>High School: Mainland High School</li>
  <li>Middle School: David C Hinson Sr Middle</li>
</ul>
<h4>Amenities and Community Features</h4>
<ul>
  <li>Community Features: Deed Restrictions, Golf Carts OK, Golf, Playground, Pool, Sidewalks</li>
</ul>
<h3>Listing</h3>
<h4>Other Property Info</h4>
<ul>
  <li>Annual Tax Amount: 900</li>
  <li>Source Listing Status: Pending</li>
  <li>County: Volusia</li>
  <li>Directions: From I-4 East, Take Exit 129, Make A Left Onto PGA Blvd, Make RIGHT On International Golf Drive (LPGA International), Make A Right On Scramble Drive Into Legends Preserve Community.</li>
  <li>Tax Year: 2023</li>
  <li>Ownership: Fee Simple</li>
  <li>Source Property Type: Residential</li>
  <li>Home Warranty: Yes</li>
  <li>Area: 32124 - Daytona Beach</li>
  <li>List Development Name: Not Assigned</li>
  <li>Source Neighborhood: LEGENDS PRESERVE - SIGNATURE</li>
  <li>Parcel Number: 15-32-20-02-00-0820</li>
  <li>Subdivision: LEGENDS PRESERVE - SIGNATURE</li>
  <li>Zoning: RES</li>
  <li>Property Subtype: Single Family Residence</li>
  <li>Source System Name: C 2 C</li>
</ul>
<h3>Features</h3>
<h4>Building and Construction</h4>
<ul>
  <li>Total Square Feet Living: 2190</li>
  <li>Year Built: 2023</li>
  <li>Builder Name: Meritage Homes</li>
  <li>Building Area Source: Builder</li>
  <li>Building Area Total: 2190</li>
  <li>Building Name: MERITAGE HOMES</li>
  <li>Construction Materials: Block, Frame</li>
  <li>Direction Faces: Northwest</li>
  <li>Foundation Details: Slab</li>
  <li>Levels: One</li>
  <li>Living Area Source: Builder</li>
  <li>Living Area Units: Square Feet</li>
  <li>Property Age: 2</li>
  <li>Property Condition: Completed</li>
  <li>Roof: Shingle</li>
  <li>Architectural Style: Traditional</li>
</ul>
<h4>Utilities</h4>
<ul>
  <li>Sewer: Public Sewer</li>
  <li>Public</li>
  <li>Underground Utilities</li>
  <li>Water Source: Public</li>
</ul>
<h4>Home Features</h4>
<ul>
  <li>Green Energy Efficient: Appliances, Lighting</li>
  <li>Other Equipment: Irrigation Equipment</li>
</ul>

        <img src="./pic1_3239.jpeg" width="806" height="604" alt="pic1" />
        <div style={{ display: "flex", gap: "0px" }}>
          <img src="./pic2_3239.webp" width="403" height="302" alt="pic2" />
          <img src="./pic3_3239.webp" width="403" height="302" alt="pic3" />
        </div>
        <img src="./pic4_3239.webp" width="806" height="604" alt="pic4" />
        <div style={{ display: "flex", gap: "0px" }}>
          <img src="./pic5_3239.webp" width="403" height="302" alt="pic5" />
          <img src="./pic6_3239.webp" width="403" height="302" alt="pic6" />
        </div>
        <img src="./pic7_3239.webp" width="806" height="604" alt="pic7" />
        <img src="./pic8_3239.webp" type="image/webp" width="806" height="604" alt="pic8" />

      </header>      
    </div>
  );
}

export default App;



